import { mergeClasses } from "@fluentui/react-components";
import { memo, type FC } from "react";
import type { IAdminSidebarItem } from "./adminSidebar.types";
import { useAdminSidebarStyles } from "./adminSidebar.styles";

interface IAdminSidebarItemProps {
  item: IAdminSidebarItem;
  isSelected: boolean;
  onSelect: (key: string) => void;
  count?: number;
  tabIndex?: number;
}

export const AdminSidebarItem: FC<IAdminSidebarItemProps> = memo(
  ({ item, isSelected, onSelect, count, tabIndex = -1 }) => {
    const styles = useAdminSidebarStyles();
    const Icon = item.icon;

    const ariaLabel =
      count !== undefined ? `${item.label}, ${count} items` : item.label;

    return (
      <button
        className={mergeClasses(
          styles.navItem,
          isSelected && styles.navItemSelected,
        )}
        onClick={() => onSelect(item.key)}
        aria-current={isSelected ? "page" : undefined}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
        data-key={item.key}
        data-selected={isSelected || undefined}
      >
        <span
          className={mergeClasses(
            styles.navItemIcon,
            isSelected && styles.navItemIconSelected,
          )}
        >
          <Icon />
        </span>
        <span
          className={mergeClasses(
            styles.navItemLabel,
            isSelected && styles.navItemLabelSelected,
          )}
        >
          {item.label}
        </span>
        {item.hasBadge && count !== undefined && (
          <span
            className={mergeClasses(
              styles.badge,
              isSelected && styles.badgeSelected,
            )}
            aria-hidden="true"
          >
            {count}
          </span>
        )}
        {item.hasBadge && count === undefined && (
          <span className={styles.badgeLoading} aria-hidden="true">
            00
          </span>
        )}
      </button>
    );
  },
);

AdminSidebarItem.displayName = "AdminSidebarItem";
